module.exports = __webpack_public_path__ + "media/application/images/2018/kiwi-gold-6d14ebb7a701d9c70100039468c75723.png";